import React from "react"
import SEO from '../../components/seo'
import Header from '../../components/header'
import Footer from '../../components/footer'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

export default function Layout({ seo, footercolor, children, env, code, main_menu, footer_menu, bgcolor })
{       
    const footer_color = footercolor !== undefined ? footercolor : ''
    const bg_color = bgcolor !== undefined ? bgcolor : 'white'   

    useScrollPosition(({ prevPos, currPos }) => 
    {
        const showForm = currPos.y < -80;

        const header = document.getElementsByTagName('header');

        header[0].className = showForm === true ? 'showform' : '';
    })

    const main_style =
    {
        background:bg_color
    }
    
    return (
        <div id="wrapper" className="layout">            

            <SEO seo={seo} />
            
            <header>
                <Header env={env} code={code} menu={main_menu} />                
            </header>

            <main style={main_style}>
                {children}
            </main>
        
            <footer className={footer_color}>
                <Footer env={env} menu={footer_menu} />
            </footer> 
        </div>
    ) 
}